import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
const requiredFirebaseConfigKeys = [
    'apiKey',
    'authDomain',
    'projectId',
    'storageBucket',
    'messagingSenderId',
    'appId',
];

const hasFirebaseConfig = requiredFirebaseConfigKeys.every((key) => Boolean(firebaseConfig[key]));

const getFirebaseMessagingWorkerUrl = () => {
    const params = new URLSearchParams(
        Object.entries(firebaseConfig).filter(([, value]) => Boolean(value)),
    );

    return `/firebase-messaging-sw.js?${params.toString()}`;
};

const getFirebaseMessaging = async () => {
    if (!hasFirebaseConfig) return null;

    const supported = await isSupported().catch(() => false);
    if (!supported) return null;

    return getMessaging(app);
};

export const requestFirebaseMessagingToken = async () => {
    if (!('Notification' in window)) return null;
    if (!('serviceWorker' in navigator)) return null;
    if (!hasFirebaseConfig) {
        console.warn('Firebase config env values are missing. Firebase notifications are not enabled.');
        return null;
    }
    if (!vapidKey) {
        console.warn('REACT_APP_FIREBASE_VAPID_KEY is missing. Firebase notifications are not enabled.');
        return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    const messaging = await getFirebaseMessaging();
    if (!messaging) return null;

    const serviceWorkerRegistration = await navigator.serviceWorker.register(getFirebaseMessagingWorkerUrl());

    return getToken(messaging, {
        vapidKey,
        serviceWorkerRegistration,
    });
};

export const listenToForegroundMessages = async (callback) => {
    const messaging = await getFirebaseMessaging();
    if (!messaging) return null;

    return onMessage(messaging, callback);
};
 
